import script from "D:\\Kryzalis\\mpardini.com.br\\src\\assets\\js\\components\\KCoockies.vue?type=script"
export * from "D:\\Kryzalis\\mpardini.com.br\\src\\assets\\js\\components\\KCoockies.vue?type=script"
export default script